KXL.module('Entities', function(Entities, KXL, Backbone, Marionette, $, _) {
	Entities.AutoRegistration = Entities.Model.extend({
		url: '/api/auth/autoregister'
	});
});
